module.exports = __webpack_public_path__ + "static/media/shift.41ff50a3.svg";